import {match} from 'ts-pattern';

import type {CustomerInsightsEntitlementStatus} from '../hooks/useCustomerInsightsEntitlements';

interface CustomerInsightsEntitledQueryStateArgs {
  enabled: boolean;
  entitled: boolean;
  entitlementStatus: CustomerInsightsEntitlementStatus;
  entitlementRetry: VoidFunction;
  isLoading: boolean;
  isError: boolean;
  retry: VoidFunction;
}

export interface CustomerInsightsEntitledQueryState {
  isOmitted: boolean;
  isLoading: boolean;
  isError: boolean;
  retry: VoidFunction;
}

/**
 * Keeps permission resolution distinct from a deliberately omitted section.
 * Until permissions settle, the section is loading; a failed permission query
 * is retryable. Data-grid queries stay disabled for both states.
 */
export function getCustomerInsightsEntitledQueryState(
  args: CustomerInsightsEntitledQueryStateArgs
): CustomerInsightsEntitledQueryState {
  const entitlementPending = args.enabled && args.entitlementStatus === 'loading';
  const entitlementFailed = args.enabled && args.entitlementStatus === 'error';

  return {
    isOmitted: !args.enabled || (args.entitlementStatus === 'ready' && !args.entitled),
    isLoading: args.isLoading || entitlementPending,
    isError: args.isError || entitlementFailed,
    retry: match(entitlementFailed)
      .with(true, () => args.entitlementRetry)
      .otherwise(() => args.retry),
  };
}
